"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unsubscribeFuturesLevel2 = exports.subscribeToFuturesLevel2 = exports.stopFuturesLevel2Subscription = exports.requestFuturesLevel2Data = exports.receiveFuturesLevel2Error = exports.initFuturesLevel2Subscription = exports.getAllFuturesLevel2 = exports.futuresLevel2Updates = exports.UNSUBSCRIBE_FUTURES_LEVEL2 = exports.SUBSCRIBE_FUTURES_LEVEL2 = exports.REQUEST_FUTURES_LEVEL2_DATA = exports.RECEIVE_FUTURES_LEVEL2_ERROR = exports.RECEIVE_FUTURES_LEVEL2_DATA = exports.FUTURES_LEVEL2_UPDATES = void 0;
var _FuturesLevel2SubscriptionService = _interopRequireDefault(require("../services/FuturesLevel2SubscriptionService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var SUBSCRIBE_FUTURES_LEVEL2 = exports.SUBSCRIBE_FUTURES_LEVEL2 = 'SUBSCRIBE_FUTURES_LEVEL2';
var UNSUBSCRIBE_FUTURES_LEVEL2 = exports.UNSUBSCRIBE_FUTURES_LEVEL2 = 'UNSUBSCRIBE_FUTURES_LEVEL2';
var RECEIVE_FUTURES_LEVEL2_DATA = exports.RECEIVE_FUTURES_LEVEL2_DATA = 'RECEIVE_FUTURES_LEVEL2_DATA';
var FUTURES_LEVEL2_UPDATES = exports.FUTURES_LEVEL2_UPDATES = 'FUTURES_LEVEL2_UPDATES';
var REQUEST_FUTURES_LEVEL2_DATA = exports.REQUEST_FUTURES_LEVEL2_DATA = 'REQUEST_FUTURES_LEVEL2_DATA';
var RECEIVE_FUTURES_LEVEL2_ERROR = exports.RECEIVE_FUTURES_LEVEL2_ERROR = 'RECEIVE_FUTURES_LEVEL2_ERROR';

/**
 * Add listener for futures level 2 updates
 */
var subscribeToFuturesLevel2 = exports.subscribeToFuturesLevel2 = function subscribeToFuturesLevel2(instrumentId) {
  return {
    type: SUBSCRIBE_FUTURES_LEVEL2,
    payload: {
      instrumentId: instrumentId
    }
  };
};

/**
 * Stop getting updates from server for passed `instrumentId`
 */
var unsubscribeFuturesLevel2 = exports.unsubscribeFuturesLevel2 = function unsubscribeFuturesLevel2(instrumentId) {
  return {
    type: UNSUBSCRIBE_FUTURES_LEVEL2,
    payload: {
      instrumentId: instrumentId
    }
  };
};
var getAllFuturesLevel2 = exports.getAllFuturesLevel2 = function getAllFuturesLevel2(updates) {
  return {
    type: RECEIVE_FUTURES_LEVEL2_DATA,
    payload: updates
  };
};
var requestFuturesLevel2Data = exports.requestFuturesLevel2Data = function requestFuturesLevel2Data(instrumentId) {
  return {
    type: REQUEST_FUTURES_LEVEL2_DATA,
    payload: instrumentId
  };
};
var futuresLevel2Updates = exports.futuresLevel2Updates = function futuresLevel2Updates(updates) {
  return {
    type: FUTURES_LEVEL2_UPDATES,
    payload: updates
  };
};
var receiveFuturesLevel2Error = exports.receiveFuturesLevel2Error = function receiveFuturesLevel2Error(error) {
  return {
    type: RECEIVE_FUTURES_LEVEL2_ERROR,
    payload: error
  };
};

/**
 * Async action to initialize subscription and fetch futures level 2 data
 */
var initFuturesLevel2Subscription = exports.initFuturesLevel2Subscription = function initFuturesLevel2Subscription(instrumentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var updates, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!_FuturesLevel2SubscriptionService["default"].isInitialized(instrumentId)) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return _FuturesLevel2SubscriptionService["default"].stop();
          case 1:
            dispatch(unsubscribeFuturesLevel2(instrumentId));
          case 2:
            dispatch(requestFuturesLevel2Data(instrumentId));
            _context.p = 3;
            _context.n = 4;
            return _FuturesLevel2SubscriptionService["default"].initSubscription(instrumentId);
          case 4:
            updates = _context.v;
            if (updates && updates.length > 0) {
              dispatch(getAllFuturesLevel2(updates));
              _FuturesLevel2SubscriptionService["default"].subscribe(function (updates) {
                var _updates$;
                if ((updates === null || updates === void 0 || (_updates$ = updates[0]) === null || _updates$ === void 0 ? void 0 : _updates$.ProductPairCode) === instrumentId) {
                  dispatch(futuresLevel2Updates(updates));
                }
              });
            }
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.error('Error initializing futures level 2 subscription:', _t);
            dispatch(receiveFuturesLevel2Error(_t));
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[3, 5]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

/**
 * Async action to stop futures level 2 subscription
 */
var stopFuturesLevel2Subscription = exports.stopFuturesLevel2Subscription = function stopFuturesLevel2Subscription(instrumentId) {
  return function (dispatch) {
    if (_FuturesLevel2SubscriptionService["default"].isInitialized(instrumentId)) {
      _FuturesLevel2SubscriptionService["default"].stop();
    }
    dispatch(unsubscribeFuturesLevel2(instrumentId));
  };
};